module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/mediumTank-prem.a4c30253.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/mediumTank-prem.png
// module id = 2726
// module chunks = 11